<app-collapsible-section 
title="Usage Limits"
[isExpanded]="isExpanded"
[isCompleted]="isCompleted"
[showDoneButton]="true"
(toggle)="onUsageLimitsToggle($event)"
(done)="onUsageLimitsDone()">
<ng-template #sectionContent>
  <div class="usage-limits-content">
    <!-- Maximum Discount Amount Section -->
    <div class="form-group">
      <label class="form-label">Maximum Discount Amount ($)</label>
      <div class="input-with-buttons">
        <div class="input-container">
          <input 
            type="number" 
            class="form-input" 
            [class.error]="hasError('maximumDiscountAmount')"
            placeholder="e.g. 5"
            [(ngModel)]="maximumDiscountAmount"
            (ngModelChange)="onFormChange()"
            (input)="preventNegativeValue('maximumDiscountAmount', $event)"
            (keydown)="preventMinusKey($event)"
            min="0"
            max="999999999">
          <div class="helper-text" *ngIf="!hasError('maximumDiscountAmount')">Enter dollar($) amount. Leave empty for unlimited.</div>
          <div class="error-text" *ngIf="hasError('maximumDiscountAmount')">{{ getError('maximumDiscountAmount') }}</div>
        </div>
        <div class="number-buttons">
          <div class="number-btn" (click)="incrementDiscountAmount()">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5L5 1L9 5" stroke="#15172E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
        </div>
          <div class="number-btn" 
               [class.disabled]="isDiscountDecrementDisabled()"
               (click)="!isDiscountDecrementDisabled() && decrementDiscountAmount()">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="#15172E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
        </div>
        </div>
      </div>
    </div>

    <!-- Quantity Limit Section -->
    <div class="form-group">
      <label class="form-label">Quantity Limit</label>
      <div class="input-with-buttons">
        <div class="input-container">
          <input 
            type="number" 
            class="form-input" 
            [class.error]="hasError('quantityLimit')"
            placeholder="e.g. 5"
            [(ngModel)]="quantityLimit"
            (ngModelChange)="onFormChange()"
            (input)="preventNegativeValue('quantityLimit', $event)"
            (keydown)="preventMinusKey($event)"
            min="0"
            max="999999999">
          <div class="helper-text" *ngIf="!hasError('quantityLimit')">Total number of customers who can redeem. Leave empty for unlimited.</div>
          <div class="error-text" *ngIf="hasError('quantityLimit')">{{ getError('quantityLimit') }}</div>
        </div>
        <div class="number-buttons">
          <div class="number-btn" (click)="incrementQuantityLimit()">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5L5 1L9 5" stroke="#15172E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </div>
          <div class="number-btn" 
               [class.disabled]="isQuantityDecrementDisabled()"
               (click)="!isQuantityDecrementDisabled() && decrementQuantityLimit()">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="#15172E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            </div>
        </div>
      </div>
    </div>

    <!-- Usage Type Selection -->
    <div class="form-group">
      <label class="form-label">Usage</label>
      <div class="usage-type-selector">
        <button 
          type="button" 
          class="usage-type-btn" 
          [class.active]="usageType === 'single'"
          [class.error]="hasError('usageType')"
          (click)="selectUsageType('single')">
          Single-Use
        </button>
        <button 
          type="button" 
          class="usage-type-btn" 
          [class.active]="usageType === 'multiple'"
          [class.error]="hasError('usageType')"
          (click)="selectUsageType('multiple')">
          Multi-Use
        </button>
      </div>
      <div class="error-text" *ngIf="hasError('usageType')">{{ getError('usageType') }}</div>
    </div>

    <!-- Multi-use Limit Section (only shown when Multi-Use is selected) -->
    <div class="form-group" *ngIf="usageType === 'multiple'">
      <label class="form-label">Multi-use Limit</label>
      <div class="input-with-buttons">
        <div class="input-container">
          <input 
            type="number" 
            class="form-input" 
            [class.error]="hasError('multiUseLimit')"
            placeholder="e.g. 5"
            [(ngModel)]="multiUseLimit"
            (ngModelChange)="onFormChange()"
            (input)="preventNegativeValue('multiUseLimit', $event)"
            (keydown)="preventMinusKey($event)"
            min="0">
          <div class="helper-text" *ngIf="!hasError('multiUseLimit')">Maximum number of times a customer can use this offer. Leave empty for unlimited.</div>
          <div class="error-text" *ngIf="hasError('multiUseLimit')">{{ getError('multiUseLimit') }}</div>
        </div>
        <div class="number-buttons">
          <div class="number-btn" (click)="incrementMultiUseLimit()">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5L5 1L9 5" stroke="#15172E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
          </div>
          <div class="number-btn" 
               [class.disabled]="isMultiUseDecrementDisabled()"
               (click)="!isMultiUseDecrementDisabled() && decrementMultiUseLimit()">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="#15172E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="platform-footer">
        <button class="btn btn-primary btn-medium" (click)="onUsageLimitsDone()">Done</button>
    </div>
  </div>
</ng-template>
</app-collapsible-section>
